import axios from 'axios';
import { API_URL as BASE_URL } from '../config';

const API_URL = `${BASE_URL}/api`;

// Create an Axios instance with common configuration
const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 10000, // 10 second timeout
  headers: {
    'Content-Type': 'application/json',
  }
});

// Add request interceptor
apiClient.interceptors.request.use(config => {
  return config;
}, error => {
  return Promise.reject(error);
});

// Add response interceptor
apiClient.interceptors.response.use(response => {
  return response;
}, error => {
  return Promise.reject(error);
});

// Fetch all applications
export const fetchApplications = async () => {
  try {
    const response = await apiClient.get(`/applications`);
    return response.data;
  } catch (error) {
    console.error('Error fetching applications:', error);
    throw error;
  }
};

// Fetch a single application by ID
export const getApplication = async (applicationId) => {
  try {
    const response = await apiClient.get(`/applications/${applicationId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching application:', error);
    throw error;
  }
};

// Create a new application
export const createApplication = async (applicationData) => {
  try {
    const response = await apiClient.post(`/applications`, applicationData);
    return response.data;
  } catch (error) {
    console.error('Error creating application:', error);
    throw error;
  }
};

// Submit an application with resume/CV files
export const submitApplication = async (applicationId, formData) => {
  try {
    const response = await apiClient.post(
      `/applications/${applicationId}/submit`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error submitting application:', error);
    throw error;
  }
};

// Update an application
export const updateApplication = async (applicationId, applicationData) => {
  try {
    const response = await apiClient.put(`/applications/${applicationId}`, applicationData);
    return response.data;
  } catch (error) {
    console.error('Error updating application:', error);
    throw error;
  }
};

// Delete an application
export const deleteApplication = async (applicationId) => {
  try {
    await apiClient.delete(`/applications/${applicationId}`);
    return true;
  } catch (error) {
    console.error('Error deleting application:', error);
    throw error;
  }
};
